'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _cssScrollHelper = require('../helpers/cssScrollHelper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CssScrollIndicator = function (_React$Component) {
  (0, _inherits3.default)(CssScrollIndicator, _React$Component);

  function CssScrollIndicator() {
    (0, _classCallCheck3.default)(this, CssScrollIndicator);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CssScrollIndicator.__proto__ || (0, _getPrototypeOf2.default)(CssScrollIndicator)).call(this));

    _this.state = {
      scrollTop: 0,
      scrollLeft: 0
    };
    return _this;
  }

  (0, _createClass3.default)(CssScrollIndicator, [{
    key: 'removeScrollListener',
    value: function removeScrollListener() {
      if (this.scrollEventListenerSet) {
        var scrollingElement = this.props.scrollingElement;
        try {
          scrollingElement.vertical().removeEventListener('scroll', this.onVerticalScroll);
        } catch (e) {
          //
        }

        try {
          var oneRow = this.props.oneRow;

          if (oneRow) {
            scrollingElement.horizontal().removeEventListener('scroll', this.onHorizontalScroll);
          }
        } catch (e) {
          //
        }
        this.scrollEventListenerSet = false;
      }
    }
  }, {
    key: 'initScrollListener',
    value: function initScrollListener() {
      var _this2 = this;

      if (this.scrollEventListenerSet) {
        this.removeScrollListener();
      }

      this.scrollEventListenerSet = true;

      var scrollingElement = this.props.scrollingElement;
      var oneRow = this.props.oneRow;

      if (oneRow) {
        //Horizontal Scroll
        this.onHorizontalScroll = function (e) {
          var target = e.currentTarget || e.target || e;
          var left = target && (target.scrollX || target.scrollLeft || target.x);
          if (left >= 0) {
            _this2.setState({
              scrollTop: left, //todo use both scrollTop and scrollLeft
              scrollLeft: left
            });
            _this2.props.getMoreItemsIfNeeded(left);
            _this2.props.enableScrollPreload();
          }
        };
        try {
          scrollingElement.horizontal().addEventListener('scroll', this.onHorizontalScroll);
        } catch (e) {
          //
        }
      } else {
        //Vertical Scroll
        this.onVerticalScroll = function (e) {
          var target = e.currentTarget || e.target || e;
          var top = target && (target.scrollY || target.scrollTop || target.y);
          if (top >= 0) {
            _this2.setState({
              scrollTop: top
            });
            _this2.props.getMoreItemsIfNeeded(top);
            _this2.props.enableScrollPreload();
          }
        };
        try {
          scrollingElement.vertical().addEventListener('scroll', this.onVerticalScroll);
        } catch (e) {
          //
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeScrollListener();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.initScrollListener();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      this.initScrollListener();
    }
  }, {
    key: 'render',
    value: function render() {
      var verticalScrollBase = !this.props.oneRow && this.props.scrollBase > 0 ? this.props.scrollBase : 0;
      var scrollTopWithoutBase = this.state.scrollTop - verticalScrollBase;
      var galleryDomId = this.props.galleryDomId;

      return _react2.default.createElement('div', { key: 'css-scroll-indicator', 'data-hook': 'css-scroll-indicator', 'data-scroll-base': verticalScrollBase, 'data-scroll-top': this.state.scrollTop, className: _cssScrollHelper.cssScrollHelper.calcScrollClasses(galleryDomId, scrollTopWithoutBase), style: { display: 'none' } });
    }
  }]);
  return CssScrollIndicator;
}(_react2.default.Component);

exports.default = CssScrollIndicator;